import { UserException } from '@/domain/user/exception/UserException'

export class InvalidInvitationContextException extends UserException {

}
